import React, { useState, useEffect } from 'react'
import { Box, Typography, IconButton, Button } from '@mui/material'
import { ArrowBack, ArrowForward } from '@mui/icons-material'
import { useSwipeable } from 'react-swipeable';

const allServices = [
  { id: 1, title: 'AirLines', image: '/images/userwebsite/b2b/org4.png' },
  { id: 2, title: '', image: '/images/userwebsite/b2b/org2.png' },
  { id: 3, title: 'Event Management', image: '/images/userwebsite/b2b/org1.png' }
]

export default function ServiceCarousel({ buttonClick }) {
  const [startIndex, setStartIndex] = useState(0)

  const handleNext = () => {
    setStartIndex((prev) => (prev + 1) % allServices.length)
  }

  const handlePrev = () => {
    setStartIndex((prev) => (prev - 1 + allServices.length) % allServices.length)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000); // Every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);


  const getCard = (offset) => {
    const index = (startIndex + offset + allServices.length) % allServices.length
    return allServices[index]
  }

  const left = getCard(0)
  const center = getCard(1)
  const right = getCard(2)

  const handlers = useSwipeable({
    onSwipedLeft: () => handleNext(),
    onSwipedRight: () => handlePrev(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
    delta: 10, // 👈 Lower means more sensitive
    trackTouch: true,
  });



  return (
    <Box sx={{ bgcolor: '#0d0d0d', py: 5, px: 2, textAlign: 'center' }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '40px', md: '48px' },
            color: 'transparent',
            background: '#6DC8BF',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Industries & Organizations
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '30px', md: '40px' },
            color: '#ffffff',
            mt: 1,
          }}
        >
          We Proudly Serve
        </Typography>

        <Typography
          variant="body1"
          sx={{
            maxWidth: '800px',
            mx: 'auto',
            color: '#9ea0a6',
            mt: 2,
            fontSize: { xs: '14px', md: '16px' },
            lineHeight: 1.6,
          }}
        >
          Our approach is built on understanding the unique operational needs of each partner,
          delivering <br /> convenience, efficiency, and service excellence at every step.
        </Typography>
      </Box>

      <Box {...handlers} sx={{ touchAction: 'pan-y', cursor: "pointer" }}>
        {/* Card Row */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 4,
            position: 'relative',
            height: { xs: 'auto', md: 500 },
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center'
          }}
        >
          {/* Left Card */}
          <Box
            sx={{
              width: 300,
              height: 300,
              borderRadius: 4,
              // overflow: 'hidden',
              position: 'relative',
              mt: 25,
              zIndex: 1,
              display: { xs: 'none', md: 'flex' },
              alignItems: 'flex-end',
              border: '1px solid #ffffff',
            }}
          >
            <Typography
              sx={{
                position: 'absolute',
                top: '-35px',
                left: '50%',
                transform: 'translateX(-50%)',
                fontSize: '72px',
                fontWeight: 900,
                letterSpacing: '2px',
                lineHeight: 1,
                background: 'linear-gradient(to bottom, #ffffff 50%, #3a1f05 50%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                zIndex: 4,
              }}
            >
              0{left.id}
            </Typography>
            <Box
              sx={{
                width: '100%',
                height: 300,
                borderRadius: 4,
                overflow: 'hidden',
                border: '1px solid white',
                position: 'relative',
              }}
            >
              <img
                src={`${process.env.IMAGE_BASE_URL}${left.image}`}
                alt={left.title}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 16,
                  left: 16,
                  color: '#fff',
                  fontSize: 20,
                  px: 2,
                  py: 0.5,
                  borderRadius: 1,
                }}
              >
                {left.title}
              </Box>
            </Box>
          </Box>

          {/* Center Card */}
          <Box sx={{
            position: 'relative',
            width: { xs: '90%', sm: 500, md: 400 }
          }}>
            <Typography
              sx={{
                position: 'absolute',
                top: '-35px',
                left: '50%',
                transform: 'translateX(-50%)',
                fontSize: '72px',
                fontWeight: 900,
                letterSpacing: '2px',
                lineHeight: 1,
                background: 'linear-gradient(to bottom, #ffffff 50%, #3a1f05 50%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                zIndex: 4,
              }}
            >
              0{center.id}
            </Typography>
            <Box
              sx={{
                width: '100%',
                height: 500,
                borderRadius: 4,
                overflow: 'hidden',
                border: '2px solid white',
                boxShadow: '0px 4px 20px rgba(0,0,0,0.5)',
                position: 'relative',
              }}
            >
              <img
                src={`${process.env.IMAGE_BASE_URL}${center.image}`}
                alt={center.title}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 16,
                  left: 16,
                  color: '#fff',
                  fontSize: 24,
                  px: 2,
                  py: 0.5,
                  borderRadius: 1,
                  fontWeight: 500,
                }}
              >
                {center.title}
              </Box>
            </Box>
          </Box>

          {/* Right Card */}
          <Box sx={{ position: 'relative', mt: -25, width: 300, display: { xs: 'none', md: 'block' }, }}>
            <Typography
              sx={{
                position: 'absolute',
                top: '-35px',
                left: '50%',
                transform: 'translateX(-50%)',
                fontSize: '72px',
                fontWeight: 900,
                letterSpacing: '2px',
                lineHeight: 1,
                // background: 'linear-gradient(to bottom, #ffffff 50%,transparent)',
                background: 'linear-gradient(to bottom, #ffffff 50%, #3a1f05 50%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                zIndex: 4,
              }}
            >
              0{right.id}
            </Typography>
            <Box
              sx={{
                width: '100%',
                height: 300,
                borderRadius: 4,
                overflow: 'hidden',
                border: '1px solid white',
                position: 'relative',
              }}
            >
              <img
                src={`${process.env.IMAGE_BASE_URL}${right.image}`}
                alt={right.title}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 16,
                  left: 16,
                  color: '#fff',
                  fontSize: 20,
                  px: 2,
                  py: 0.5,
                  borderRadius: 1,
                }}
              >
                {right.title}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: { xs: 'start', md: 'flex-end' },
          gap: 2,
          mt: { xs: 3, md: 3 },
          paddingRight: { xs: 0, md: 27 }
        }}
      >
        <IconButton
          onClick={handlePrev}
          sx={{
            bgcolor: '#ccc',
            width: 50,
            height: 50,
            '&:hover': { bgcolor: '#aaa' },
          }}
        >
          <ArrowBack />
        </IconButton>
        <IconButton
          onClick={handleNext}
          sx={{
            background: 'linear-gradient(to right, #7db5b8, #397d91)',
            width: 50,
            height: 50,
            '& svg': { color: '#fff' },
          }}
        >
          <ArrowForward />
        </IconButton>
      </Box>

      {/* Pagination Dots */}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5, mt: 4 }}>
        {allServices.map((_, i) => {
          const isActive = i === startIndex

          return (
            <Box
              key={i}
              onClick={() => setStartIndex(i)}
              sx={{
                width: isActive ? 32 : 12,
                height: 12,
                borderRadius: 12,
                bgcolor: isActive ? '#fff' : '#888',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                '&:hover': {
                  bgcolor: '#fff',
                },
              }}
            />
          )
        })}

      </Box>


      {/* CTA Button */}
      <Box textAlign="center" mt={4}>
        <Button
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          sx={{
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 600,
            borderRadius: '8.87px',
            background:
              'linear-gradient(to right, #9CD0C9, #32788E)',
            color: '#fff',
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              background:
                'linear-gradient(to right, #7BB9B2, #245E6E)',
              boxShadow: 'none'
            }
          }}
          onClick={buttonClick}
        >
          Join Now
        </Button>
      </Box>
    </Box>
  )
}
